import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

// PROPOSAL CONTENT
export const getProposalContent = createSelector(
    getModel,
    (model) => model.proposalContent,
);

export const getIsFetchingProposalContent = createSelector(
    getProposalContent,
    (value) => value.isFetching,
);

export const getProposalContentErrors = createSelector(
    getProposalContent,
    (value) => value.errors,
);
